import React from 'react'
import { RETURN_PERIOD_BANDS } from '../../../import/constants/IndicatorsConstants'

const ReturnPeriodSwatch = () => (
    <div style={{ display: 'flex', borderRadius: '4px', overflow: 'hidden' }}>
        {RETURN_PERIOD_BANDS.map(({ code, color }) => (
            <div key={code} style={{ width: '0.5rem', height: '0.75rem', backgroundColor: color }} />
        ))}
    </div>
)

export default ReturnPeriodSwatch
